export default __webpack_public_path__ + "static/media/smartmockups-kkfuumup-796x998.12edcdac.845d13d4.png";